/**
 * Grand Quack Auto — duck voice line synth (C3).
 *
 * Synthesized quack-talk bleats via Web Audio API.
 * Normal quack: random multi-syllable chirps (30% chance).
 * Mega-quack: dramatic descending sweep (always).
 */

import { VOICE } from '../config';
import { getCtx, getDestination } from './audioMixer';

/** Play a short multi-syllable duck voice bleat (square wave, random pitch). */
export function playVoiceLine(): void {
  const c = getCtx();
  if (c.state === 'suspended') c.resume();
  const now = c.currentTime;
  for (let i = 0; i < VOICE.bleatCount; i++) {
    const t = now + i * (VOICE.bleatDuration + VOICE.bleatGap);
    const freq = VOICE.freqMin + Math.random() * (VOICE.freqMax - VOICE.freqMin);
    const osc = c.createOscillator();
    osc.type = 'square';
    osc.frequency.setValueAtTime(freq, t);
    osc.frequency.setValueAtTime(freq * 1.1, t + VOICE.bleatDuration * 0.5);
    osc.frequency.setValueAtTime(freq * 0.9, t + VOICE.bleatDuration);
    const g = c.createGain();
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(0.12, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.001, t + VOICE.bleatDuration);
    osc.connect(g).connect(getDestination());
    osc.start(t);
    osc.stop(t + VOICE.bleatDuration + 0.01);
  }
}

/** Dramatic descending sweep for mega-quack — always plays. */
export function playMegaVoiceLine(): void {
  const c = getCtx();
  if (c.state === 'suspended') c.resume();
  const now = c.currentTime;
  const osc = c.createOscillator();
  osc.type = 'sawtooth';
  osc.frequency.setValueAtTime(VOICE.megaSweepStart, now);
  osc.frequency.exponentialRampToValueAtTime(VOICE.megaSweepEnd, now + VOICE.megaSweepDuration);
  const g = c.createGain();
  g.gain.setValueAtTime(0.18, now);
  g.gain.exponentialRampToValueAtTime(0.001, now + VOICE.megaSweepDuration);
  osc.connect(g).connect(getDestination());
  osc.start(now);
  osc.stop(now + VOICE.megaSweepDuration + 0.01);
}
